import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import { ISLAM_OPENING, ISLAM_SECTIONS, type IslamPart, keepHonorifics } from '../data/islam';
import { panel } from '../state';
import { Sheet } from './chrome';
import { Quote } from './Quote';

// What Islam teaches about the stars, astrology and the old names in the sky, with the evidence: the Quran, the
// hadith and the scholars quoted word for word, each with its reference in the books (src/ui/Quote.tsx).

/** The section to open the page at (a meteor's card opens it at the shooting-stars article). */
export const islamFocus = signal<string | null>(null);

/** Opens "The stars in Islam", at a section if one is named. */
export function openIslam(section: string | null = null) {
  islamFocus.value = section;
  panel.value = 'islam';
}

const Part = ({ part }: { part: IslamPart }) => (typeof part === 'string' ? <p>{keepHonorifics(part)}</p> : <Quote id={part.quote} />);

export function IslamPanel() {
  useEffect(() => {
    const id = islamFocus.peek();
    if (!id) return;
    islamFocus.value = null;
    requestAnimationFrame(() => document.getElementById(`islam-${id}`)?.scrollIntoView({ block: 'start' }));
  }, []);
  return (
    <Sheet onClose={() => (panel.value = null)} size="tall" label="The stars in Islam">
      <h2 class="sheet-title">The stars in Islam</h2>
      <p class="sheet-lead">What the Quran and the Sunnah teach about the stars, astrology and the old names in the sky.</p>
      <section class="islam-sec islam-opening">
        {ISLAM_OPENING.map((part, i) => <Part key={i} part={part} />)}
      </section>
      {ISLAM_SECTIONS.map((sec) => (
        <section class="islam-sec" key={sec.title} id={sec.id ? `islam-${sec.id}` : undefined}>
          <h3>{sec.title}</h3>
          {sec.parts.map((part, i) => <Part key={i} part={part} />)}
        </section>
      ))}
    </Sheet>
  );
}
